import script from "./small-image-tile-band.vue?vue&type=script&lang=js"
export * from "./small-image-tile-band.vue?vue&type=script&lang=js"

import "./small-image-tile-band.vue?vue&type=style&index=0&id=aca771ac&lang=scss"

const __exports__ = script;

export default __exports__